import { bugsnagClient } from '@Services/observability/initObservability';
import { type RawConvertData } from './types';
import { getVariationKeyFromRawKey, isValidExperienceId } from './util';

interface ParseExperimentsParams {
  convertData?: RawConvertData;
}
export const parseExperiments = ({ convertData }: ParseExperimentsParams) => {
  if (!convertData?.experiences) {
    return [];
  }

  return Object.entries(convertData.experiences)
    .map(([experienceId, data]) => {
      const variation = data.variation;
      if (!variation || !variation.key || !variation.id) {
        bugsnagClient.notify(
          new Error(`Experience ${experienceId} has malformed variation data: ${variation}`)
        );
        return null;
      }
      if (!isValidExperienceId(experienceId)) {
        bugsnagClient.notify(new Error(`Experience ${experienceId} is not a valid experience ID`));
        return null;
      }

      const variationKey = getVariationKeyFromRawKey(variation.key);
      if (!variationKey) {
        bugsnagClient.notify(
          new Error(`Variation key ${variation.key} is not a valid variation key`)
        );
        return null;
      }
      return {
        id: experienceId,
        variationKey,
      };
    })
    .filter((experience) => experience !== null);
};
